import { FC, useMemo } from 'react'
import { useGalleryProduct, useGalleryVisualsMeta } from '../../contexts'

import { GallerySection } from 'components/common/Gallery/GallerySection/GallerySection.component'
import { useTranslation } from 'react-i18next'

/**
 * @interface Props
 */
interface Props {
  /** JSX elements that we render in section as unpurchased */
  unPurchasedVisuals: JSX.Element
}

/**
 * Client gallery photo section unpurchased visuals
 * 
 * @example <ClientGalleryPhotoSectionFilteredUnpurchased />
 */
export const ClientGalleryPhotoSectionFilteredUnpurchased: FC<Props> = ({ unPurchasedVisuals }) => {

  const { t } = useTranslation(['gallery'])
  const { prepurchasedVisualsRemaining } = useGalleryVisualsMeta()
  const { isSelfUploadProduct } = useGalleryProduct()

  const unpurchasedVisualsTitle = useMemo(() => {
    if (isSelfUploadProduct) {
      return t('visuals_unselected_title_for_self_upload')
    }

    return `${t('visuals_unpurchased_title')} ${prepurchasedVisualsRemaining > 0 ? `- ${t('prepaid_remaining', { count: prepurchasedVisualsRemaining })}` : ''}`
  }, [isSelfUploadProduct, prepurchasedVisualsRemaining, t])

  const unpurchasedVisualsSubTitle = useMemo(() => {
    if (isSelfUploadProduct) {
      return t('visuals_unselected_subtitle_for_self_upload')
    }

    return t('visuals_unpurchased_subtitle')
  }, [isSelfUploadProduct, t])

  return (
    <GallerySection
      title={unpurchasedVisualsTitle}
      subTitle={unpurchasedVisualsSubTitle}
    >
      {unPurchasedVisuals}
    </GallerySection>
  )
}
